import React from "react"

const Einzelzimmer = (props) => {
  if (props.preisEinzelzimmer !== null) {
    return (
      <tbody>
        <tr style={{ border: `none` }}>
          <td colSpan="2" style={{ border: `none` }}>
            {props.textEinzelzimmer}
          </td>
          <td style={{ border: `none`, whiteSpace: `nowrap` }}>
            {props.preisEinzelzimmer}
          </td>
        </tr>
      </tbody>
    )
  } else {
    return null
  }
}
export default Einzelzimmer
